import React from 'react';

import TaxExemptWidget from "../below/TaxExemptWidget";
import ChannelPicker from "./ChannelPicker";
import AgentShippingWidget from "../below/AgentShippingWidget";

export default function AgentBelowCartToolbar({...props}) {
  const {currentAgent} = props;
  if (!currentAgent || !currentAgent.id)
    return null;

  return (
    <div className="relative border-2 border-red-900">
      <div className="absolute -left-8 top-0">
        <div className="fa fa-user-secret"></div>
      </div>

      <div className="bg-agent-purple">
        <div className="grid grid-cols-3">
          <div><ChannelPicker {...props} /></div>
          <div><TaxExemptWidget {...props} /></div>
          <div><AgentShippingWidget {...props} /></div>
        </div>
      </div>
    </div>
  );
}

//
